export const periodValues = Object.freeze({
  HALF_DAY: "HALF_DAY",
  ONE_DAY: "GET",
  TWO_DAYS: "POST",
  FOUR_DAYS: "HEAD",
  SEVEN_DAYS: "SEVEN_DAYS",
  MONTH: "MONTH",
});